<template>
	<label class="omapi-integrations-form__field-wrap">
		<div class="omapi-integrations-form__field-wrap-label" :class="{ large: largeLabel }">
			<common-tooltip v-if="tooltip" tooltip="">
				<span>{{ tooltip }}</span>
			</common-tooltip>
			<span v-else>{{ field.label }}</span>
		</div>
		<div class="omapi-integrations-form__field-wrap-field">
			<input
				:type="fieldType"
				:name="field.id"
				class="omapi-input"
				v-bind="$attrs"
				@input="$emit('input', $event.target.value)"
			/>
		</div>
	</label>
</template>
<script>
export default {
	props: {
		/**
		 * Field object.
		 */
		field: {
			type: Object,
			required: true,
		},
		largeLabel: Boolean,
	},
	computed: {
		/**
		 * Show Field
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Should the field be visible?
		 */
		showField() {
			return !!this.$get('field.label', '');
		},
		/**
		 * Field Type
		 *
		 * @since 2.4.0
		 *
		 * @returns {string} The field type.
		 */
		fieldType() {
			if (!this.showField) {
				return 'hidden';
			}

			return this.$get('field.type', 'text');
		},
		/**
		 * Has Tooltip
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Does the field data contain a tooltip?
		 */
		tooltip() {
			return this.$get('field.tooltip', '');
		},
	},
};
</script>
